import styled from 'styled-components';

export const SelectGroupDrawerWrapper = styled.div`
    .add-edit-config-drawer .ant-drawer-content-wrapper {
        max-width: 60vw;
    }
`;
